import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem
} from "@mui/material";
import { Box } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

import {
  fetchBeacons,
  addBeacon,
  updateBeacon,
  deleteBeacon
} from "../../services/beaconService";
import { fetchLocations } from "../../services/locationService";

import AppHeader from "../../components/AppHeader";

export default function BeaconPage({ setIsLoggedIn }) {
  const [beacons, setBeacons] = useState([]);
  const [locations, setLocations] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");

  const [form, setForm] = useState({
    beacon_name: "",
    location_id: ""
  });

  const loadBeacons = async () => {
    const res = await fetchBeacons();
    setBeacons(res);
  };

  const loadLocations = async () => {
    const res = await fetchLocations();
    setLocations(res);  // store in React state
  };

  useEffect(() => {
    loadBeacons();
    loadLocations();
  }, []);

  const handleOpenAdd = () => {
    setEditing(null);
    setForm({
      beacon_name: "",
      location_id: ""
    });
    setOpen(true);
  };

  const handleOpenEdit = (b) => {
    setEditing(b.beacon_id);
    setForm({
      beacon_name: b.beacon_name,
      location_id: b.location_id
    });
    setOpen(true);
  };

  const handleSave = async () => {
    if (editing !== null) {
      await updateBeacon(editing, form);
    } else {
      await addBeacon(form);
    }
    setOpen(false);
    loadBeacons();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this beacon?")) {
      await deleteBeacon(id);
      loadBeacons();
    }
  };

  const filteredBeacons = beacons.filter((b) =>
    b.beacon_name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <AppHeader />

      {/* PAGE HEADER */}
      <Box
        sx={{
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#e8f5e9",
          color: "#1b5e20"
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", marginLeft: "45px" }}>
          Beacons Setup
        </Typography>

        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <TextField
            label="Search Beacons"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ width: "250px" }}
          />

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenAdd}
            sx={{
              backgroundColor: "#ffffff",
              color: "#1b5e20",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#e8e8e8" }
            }}
          >
            Add Beacon
          </Button>
        </div>
      </Box>

      {/* TABLE */}
      <TableContainer
        component={Paper}
        sx={{
          mt: 2,
          p: 2,
          mx: "auto",
          width: "90%",
          maxWidth: "1400px",
          borderRadius: "8px"
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Name</b></TableCell>
              <TableCell><b>Location ID</b></TableCell>
              <TableCell><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredBeacons.map((b) => (
              <TableRow key={b.beacon_id}>
                <TableCell>{b.beacon_name}</TableCell>
                <TableCell>{b.location_name}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleOpenEdit(b)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(b.beacon_id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {filteredBeacons.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No beacons found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ADD/EDIT DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          {editing !== null ? "Edit Beacon" : "Add Beacon"}
        </DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            label="Beacon Name"
            margin="dense"
            value={form.beacon_name}
            onChange={(e) => setForm({ ...form, beacon_name: e.target.value })}
          />
          <Select
            fullWidth
            value={form.location_id}
            onChange={(e) => setForm({ ...form, location_id: e.target.value })}
            displayEmpty
            margin="dense"
            style={{ marginTop: 16 }}
          >
            <MenuItem value="">
              <em>Select Location</em>
            </MenuItem>

            {locations.map((loc) => (
              <MenuItem key={loc.id} value={loc.id}>
                {loc.location_name}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}